import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=fb15ca16&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb15ca16')) {
      api.createRecord('fb15ca16', component.options)
    } else {
      api.reload('fb15ca16', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=fb15ca16&", function () {
      api.rerender('fb15ca16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ix918rsNzVKp/JS/comp/ErrorMessage.vue"
export default component.exports